module.exports = __webpack_public_path__ + "static/media/icon_system_social_facebook.6263c470.svg";